import * as type from '../types/clients'

export const retrieveCompanyClientsList = payload => {
    return{
        type: type.REQUEST_COMPANY_CLIENTS_CONTENT,
        payload: payload
    }
}

export const resetCompanyClientsList = () => {
    return{
        type: type.RESET_COMPANY_CLIENTS_CONTENT
    }
}

export const retrievePersonClientsList = payload => {
    return{
        type: type.REQUEST_PERSON_CLIENTS_CONTENT,
        payload: payload
    }
}

export const resetPersonClientsList = () => {
    return{
        type: type.RESET_PERSON_CLIENTS_CONTENT
    }
}

export const changeClientsModal = payload => {
    return{
        type: type.CHANGE_CLIENTS_MODALS,
        modal: payload
    }
}

export const setActiveClientDeletion = payload => {
    return{
        type: type.SET_ACTIVE_CLIENT_DELETION,
        data: payload
    }
}

export const resetActiveClientDeletion = payload => {
    return{
        type: type.RESET_ACTIVE_CLIENT_DELETION
    }
}

export const setActiveClientDisplay = payload => {
    return{
        type: type.SET_ACTIVE_CLIENT_DISPLAY,
        client: payload
    }
}

export const resetActiveClientDisplay = payload => {
    return{
        type: type.RESET_ACTIVE_CLIENT_DISPLAY
    }
}

export const requestUpdateSingleClient = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_CLIENT,
        details: payload
    }
}

export const resetUpdateSingleClient = () => {
    return{
        type: type.RESET_UPDATE_SINGLE_CLIENT
    }
}

export const requestDeleteSingleClient = payload => {
    return{
        type: type.REQUEST_DELETE_SINGLE_CLIENT,
        details: payload
    }
}

export const resetDeleteSingleClient = () => {
    return{
        type: type.RESET_DELETE_SINGLE_CLIENT
    }
}

export const requestSearchSingleClient = payload => {
    return{
        type: type.REQUEST_SEARCH_SINGLE_CLIENT,
        id: payload
    }
}

export const resetSearchSingleClient = () => {
    return{
        type: type.RESET_SEARCH_SINGLE_CLIENT,
    }
}

export const requestAddSingleClient = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_CLIENT,
        details: payload
    }
}

export const resetAddSingleClient = () => {
    return{
        type: type.RESET_ADD_SINGLE_CLIENT
    }
}

export const appendDeletionArray = payload => {
    return{
        type: type.APPEND_CLIENTS_DELETION_ARRAY,
        id: payload
    }
}

export const subtractDeletionArray = payload => {
    return{
        type: type.SUBTRACT_CLIENTS_DELETION_ARRAY,
        id: payload
    }
}

export const requestDeleteClientArray = payload => {
    return{
        type: type.REQUEST_DELETE_CLIENT_ARRAY,
        details: payload
    }
}

export const resetDeleteClientArray = () => {
    return{
        type: type.RESET_DELETE_CLIENT_ARRAY
    }
}

